import React from "react";
import FrontFooter from "../shared/FrontFooter/FrontFooter";
import Navbar from "../../sections/Navbar";
import { Outlet } from "react-router-dom";

const MonCompteLayout = () => {
  return (
    <div className="landing-page-component">
      <Navbar />
      <div className="page-content pb-5">
        <div className="container-easy-market">
          <div className="user-parcours mb-5">
            <div className="content-col-right-register-page">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      {/* <FooterPage /> */}
      <FrontFooter />
    </div>
  );
};

export default MonCompteLayout;
